<h1 mat-dialog-title>{{ data?.title }}</h1>
<div mat-dialog-content>
  <div *ngIf="order && sageUiEnabled" class="sage-row mb-2">
    <span>Sage: {{ getSageSyncLabel() }}</span>
    <span *ngIf="order?.sage_invoice_id"> ({{ order?.sage_invoice_id }})</span>
    <button type="button" mat-stroked-button class="ms-2" (click)="syncOrderToSage()">
      <mat-icon>sync_alt</mat-icon> Sync to Sage
    </button>
  </div>




    <!---------------------------------------------------Collection address--------------------------------------------------------------->





    <mat-stepper *ngIf="!waybillWasCaptured" linear #stepper>
        <mat-step [stepControl]="senderAddressForm">
            <form [formGroup]="senderAddressForm">
                <ng-template matStepLabel>Collection address</ng-template>

                <div class="row">

                    <div class="col-md-6">
                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>City</mat-label>
                                <input type="text" formControlName="city" matInput placeholder="City" />
                                <mat-error *ngIf="senderAddressForm.get('city')?.invalid">
                                    City is invalid, should have a maximum of 30 characters 
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Street</mat-label>
                                <input required type="text" formControlName="street" matInput placeholder="Street" />
                                <mat-error *ngIf="senderAddressForm.get('street')?.invalid">
                                    Street is invalid, should have a maximum of 30 characters 
                                </mat-error>
                            </mat-form-field>
                        </p>


                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Building complex name</mat-label>
                                <input type="text" formControlName="buildingComplexName" matInput
                                    placeholder="Building complex name" />
                                <mat-error *ngIf="senderAddressForm.get('buildingComplexName')?.invalid">
                                    Building complex name is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>


                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Postal code</mat-label>
                                <input type="text" formControlName="postalCode" matInput placeholder="Postal code" />
                                <mat-error *ngIf="senderAddressForm.get('postalCode')?.invalid">
                                    Postal code is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Work tel</mat-label>
                                <input required type="text" formControlName="workTel" matInput placeholder="Work tel" />
                                <mat-error *ngIf="senderAddressForm.get('workTel')?.invalid">
                                    Work tel is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>


                    </div>

                    <div class="col-md-6">

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Suburb</mat-label>
                                <input required type="text" formControlName="surburb" matInput placeholder="Surburb" />
                                <mat-error *ngIf="senderAddressForm.get('surburb')?.invalid">
                                    Surburb is invalid, should have a maximum of 30 characters 
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Building number</mat-label>
                                <input type="number" min="1" formControlName="buildingNumber" matInput
                                    placeholder="Building number" />
                                <mat-error *ngIf="senderAddressForm.get('buildingNumber')?.invalid">
                                    Building number is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Unit</mat-label>
                                <input type="number" min="1" formControlName="unit" matInput placeholder="Unit" />
                                <mat-error *ngIf="senderAddressForm.get('unit')?.invalid">
                                    Unit is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>



                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Contact person</mat-label>
                                <input required type="text" formControlName="contactPerson" matInput
                                    placeholder="Contact person" />
                                <mat-error *ngIf="senderAddressForm.get('contactPerson')?.invalid">
                                    Contact person is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>



                    </div>


                </div>

            </form>


            <div class="text-end">
                <button [disabled]="senderAddressForm.invalid" matStepperNext mat-raised-button color="primary">
                    <mat-icon>chevron_right</mat-icon> Next
                </button>
            </div>
        </mat-step>




        <!-----------------------------------------------------------Delivery address------------------------------------------------------>

        <mat-step [stepControl]="deliveryAddressForm">
            <form [formGroup]="deliveryAddressForm">
                <ng-template matStepLabel>Delivery address</ng-template>

                <div class="row">

                    <div class="col-md-6">

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>City</mat-label>
                                <input type="text" formControlName="city" matInput placeholder="City" />
                                <mat-error *ngIf="deliveryAddressForm.get('city')?.invalid">
                                    City is invalid, should have a maximum of 30 characters 
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Street</mat-label>
                                <input required type="text" formControlName="street" matInput placeholder="Street" />
                                <mat-error *ngIf="deliveryAddressForm.get('street')?.invalid">
                                    Street is invalid, should have a maximum of 30 characters 
                                </mat-error>
                            </mat-form-field>
                        </p>


                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Building complex name</mat-label>
                                <input type="text" formControlName="buildingComplexName" matInput
                                    placeholder="Building complex name" />
                                <mat-error *ngIf="deliveryAddressForm.get('buildingComplexName')?.invalid">
                                    Building complex name is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>


                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Postal code</mat-label>
                                <input type="text" formControlName="postalCode" matInput placeholder="Postal code" />
                                <mat-error *ngIf="deliveryAddressForm.get('postalCode')?.invalid">
                                    Postal code is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Cell number</mat-label>
                                <input required type="text" formControlName="cell" matInput placeholder="Cell number" />
                                <mat-error *ngIf="deliveryAddressForm.get('cell')?.invalid">
                                    Cell number is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>


                    </div>

                    <div class="col-md-6">

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Surburb</mat-label>
                                <input required type="text" formControlName="surburb" matInput placeholder="Surburb" />
                                <mat-error *ngIf="deliveryAddressForm.get('surburb')?.invalid">
                                    Surburb is invalid, should have a maximum of 30 characters 
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Building number</mat-label>
                                <input type="number" min="1" formControlName="buildingNumber" matInput
                                    placeholder="Building number" />
                                <mat-error *ngIf="deliveryAddressForm.get('buildingNumber')?.invalid">
                                    Building number is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Unit</mat-label>
                                <input type="number" min="1" formControlName="unit" matInput placeholder="Unit" />
                                <mat-error *ngIf="deliveryAddressForm.get('unit')?.invalid">
                                    Unit is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>



                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Contact person</mat-label>
                                <input required type="text" formControlName="contactPerson" matInput
                                    placeholder="Contact person" />
                                <mat-error *ngIf="deliveryAddressForm.get('contactPerson')?.invalid">
                                    Contact person is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>


                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Company</mat-label>
                                <input type="text" formControlName="company" matInput placeholder="Company" />
                                <mat-error *ngIf="deliveryAddressForm.get('company')?.invalid">
                                    Contact person is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>



                    </div>


                </div>


            </form>

            <div class="text-end">

                <button class="me-2" matStepperPrevious mat-raised-button color="primary">
                    <mat-icon>chevron_left</mat-icon> Previous
                </button>

                <button [disabled]="deliveryAddressForm.invalid" matStepperNext mat-raised-button color="primary">
                    <mat-icon>chevron_right</mat-icon> Next
                </button>
            </div>

        </mat-step>




        <!----------------------------------------------------------Add parcels--------------------------------------------------------->


        <mat-step [stepControl]="serviceTypeForm">
            <ng-template matStepLabel> Add Parcels</ng-template>

            <form [formGroup]="serviceTypeForm">
                <p>
                    <mat-form-field appearance="outline">
                        <mat-label>Service type</mat-label>
                        <mat-select required formControlName="type">
                            <mat-option [value]="type.code" *ngFor="let type of serviceTypes">
                                {{type.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </p>
            </form>
            <div class="py-2">
                <mat-divider></mat-divider>
            </div>
            <core-add-parcel (onAddParcel)="addParcel($event)" [waybillNo]="waybillNo"></core-add-parcel>
            <div class="my-2">
                <core-parcel-list [parcels]="parcels" (onDelete)="deleteParcel($event)"></core-parcel-list>
            </div>

            <div class="my-2 text-end">

                <button class="me-2" matStepperPrevious mat-raised-button color="primary">
                    <mat-icon>chevron_left</mat-icon> Previous
                </button>

                <button [disabled]="parcels.length === 0" (click)="prepareWaybill()" mat-raised-button color="primary">
                    <mat-icon>chevron_right</mat-icon> Next
                </button>

            </div>
        </mat-step>



        <!----------------------------------------------------------Review and capture--------------------------------------------------------->




        <mat-step (interacted)="hideNext = !hideNext">
            <ng-template matStepLabel>Review</ng-template>
            <core-waybill-review *ngIf="waybillPayload" [waybillPayload]="waybillPayload"></core-waybill-review>

            <div class="my-2 text-end">

                <button class="me-2" matStepperPrevious mat-raised-button color="primary">
                    <mat-icon>chevron_left</mat-icon> Previous
                </button>

                <button [disabled]="!waybillPayload || isLoading" (click)="captureWaybill()" mat-raised-button
                    color="primary">
                    Capture waybill
                </button>

            </div>
        </mat-step>

        <mat-step>
            <ng-template matStepLabel>Complete</ng-template>
            <button class="me-2" mat-raised-button color="primary" *ngFor="let link of labelLinks" (click)="viewLabel(link)">
                <mat-icon>open_in_new</mat-icon> Download Label
            </button>
        </mat-step>
    </mat-stepper>

</div>

<div mat-dialog-actions align="end">
    <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
    <button mat-raised-button color="primary" [disabled]="!waybillCompleted"  [mat-dialog-close]="true">Done</button>
</div>